module.exports = __webpack_public_path__ + "img/bot_intent_zhishiku_ac.de0e3131.svg";